import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.chatbot');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-chatbot',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.chatbot/view.scss */
:host {
  display: block;
}

@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.animate-slide-in {
  animation: slide-in 0.2s ease-out;
}`],
})
export class ComponentChatbotComponent implements OnInit {
    public isOpen: boolean = false;
    public inputText: string = '';
    public loading: boolean = false;
    public messages: any[] = [];
    public suggestions: string[] = [
        '농장 관리',
        '생산 현황',
        '계란 시세',
        'AS 신청',
        '모니터링'
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.messages = [
            {
                role: 'bot',
                text: '안녕하세요! 에그텍 AI 도우미입니다. 무엇을 도와드릴까요?'
            }
        ];
        await this.service.render();
    }

    public async toggleChat() {
        this.isOpen = !this.isOpen;
        await this.service.render();
        if (this.isOpen) {
            setTimeout(() => this.scrollToBottom(), 100);
        }
    }

    public async sendMessage(text?: string) {
        const message = text || this.inputText?.trim();
        if (!message) return;

        this.messages.push({ role: 'user', text: message });
        this.inputText = '';
        this.loading = true;
        await this.service.render();
        this.scrollToBottom();

        try {
            const res = await wiz.call('chat', { message });
            if (res.code === 200) {
                const data = res.data;
                const botMsg: any = { role: 'bot', text: data.text || '' };

                if (data.html) botMsg.html = data.html;
                if (data.link) {
                    botMsg.link = data.link;
                    botMsg.linkText = data.linkText || '이동하기';
                }

                this.messages.push(botMsg);
            } else {
                this.messages.push({
                    role: 'bot',
                    text: '죄송합니다. 요청을 처리하는 중 오류가 발생했습니다.'
                });
            }
        } catch (e) {
            this.messages.push({
                role: 'bot',
                text: '네트워크 오류가 발생했습니다. 다시 시도해주세요.'
            });
        }

        this.loading = false;
        await this.service.render();
        this.scrollToBottom();
    }

    private scrollToBottom() {
        try {
            const el = document.querySelector('#chatMessages');
            if (el) el.scrollTop = el.scrollHeight;
        } catch (e) { }
    }
}

export default ComponentChatbotComponent;